import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { useState } from "react";
import { NumericFormat } from "react-number-format";
import { numberFormat } from "../../extends/NumberFormat";

const PaymentEntryField = withStyles({
  root: {
    borderBottom: `1px solid #0091ff`,
    "& .MuiInput-underline:after": {
      borderBottom: `1px solid #0091ff`,
    },
  },
})((props) => <TextField {...props} variant="standard" />);

const PaymentGratuity = ({
  options = [],
  value,
  tppPayGratuityAmount,
  paymentGratuityOption,
  onCustomGratuityChange,
  onOptionChange,
}) => {
  const [selectedOption, setSelectedOption] = useState(value);

  const handleOptionChange = (e, value) => {
    const nValue = parseFloat(value);
    setSelectedOption((prev) => {
      if (onOptionChange) {
        onOptionChange(nValue);
      }
      return nValue;
    });
  };

  const GratuityOption = ({ value, label = null }) => {
    const display = !label || !label.length ? `${value}%` : label;
    return (
      <FormControlLabel
        value={value}
        control={
          <Radio
            style={{ padding: 0 }}
            icon={
              <Button color="info" variant="contained" sx={{ padding: 0.5 }}>
                {display}
              </Button>
            }
            checkedIcon={
              <Button color="success" variant="contained" sx={{ padding: 0.5 }}>
                {display}
              </Button>
            }
          />
        }
      />
    );
  };

  if (!options || !options.length) {
    return <></>;
  }
  return (
    <Stack gap={1}>
      {paymentGratuityOption !== 0 ? (
        <Typography sx={{ fontWeight: "bold" }} variant="subtitle1">
          {numberFormat(tppPayGratuityAmount)}
        </Typography>
      ) : (
        <NumericFormat
          thousandSeparator
          fixedDecimalScale
          decimalScale={2}
          allowNegative={false}
          prefix="$"
          value={tppPayGratuityAmount}
          onValueChange={(values) => onCustomGratuityChange(values.floatValue)}
          customInput={PaymentEntryField}
        />
      )}
      <Stack gap={1} mx={1}>
        <RadioGroup
          row={true}
          value={selectedOption}
          onChange={handleOptionChange}
          name="selectedGratuity"
        >
          {options.map((opt) => (
            <GratuityOption
              value={opt?.value}
              label={opt?.label}
            ></GratuityOption>
          ))}
        </RadioGroup>
      </Stack>
    </Stack>
  );
};

export default PaymentGratuity;
